var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.8333H13.3333V8.50001H11.1C10.15 10.5167 8.1 11.8333 5.83333 11.8333C2.61667 11.8333 0 9.21667 0 6.00001C0 2.78334 2.61667 0.166672 5.83333 0.166672C8.1 0.166672 10.1417 1.48334 11.1 3.50001H20V8.50001H18.3333V11.8333ZM15 10.1667H16.6667V6.83334H18.3333V5.16667H9.95L9.75833 4.60834C9.175 2.95001 7.59167 1.83334 5.83333 1.83334C3.53333 1.83334 1.66667 3.70001 1.66667 6.00001C1.66667 8.30001 3.53333 10.1667 5.83333 10.1667C7.59167 10.1667 9.175 9.05001 9.75833 7.39167L9.95 6.83334H15V10.1667ZM5.83333 8.50001C4.45833 8.50001 3.33333 7.37501 3.33333 6.00001C3.33333 4.62501 4.45833 3.50001 5.83333 3.50001C7.20833 3.50001 8.33333 4.62501 8.33333 6.00001C8.33333 7.37501 7.20833 8.50001 5.83333 8.50001ZM5.83333 5.16667C5.375 5.16667 5 5.54167 5 6.00001C5 6.45834 5.375 6.83334 5.83333 6.83334C6.29167 6.83334 6.66667 6.45834 6.66667 6.00001C6.66667 5.54167 6.29167 5.16667 5.83333 5.16667Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.cf7695f4.svg";
export { ForwardRef as ReactComponent };